import { render, staticRenderFns } from "./indexCalification.vue?vue&type=template&id=22f6b008&scoped=true&"
import script from "./indexCalification.vue?vue&type=script&lang=ts&"
export * from "./indexCalification.vue?vue&type=script&lang=ts&"
import style0 from "./indexCalification.vue?vue&type=style&index=0&id=22f6b008&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f6b008",
  null
  
)

export default component.exports